// main.js - Svelte 앱 진입점
import './app.css';
import * as Sentry from '@sentry/svelte';
import { mount } from 'svelte';
import App from './App.svelte';

// Web app version - injected by Vite at build time
export const WEB_VERSION = typeof __WEB_VERSION__ !== 'undefined' ? __WEB_VERSION__ : 'dev';

// Sentry 초기화 (반드시 앱 마운트 전에)
Sentry.init({
  dsn: 'https://b03dcc68398b0f08aadea915373a2bf4@o4510825991372801.ingest.us.sentry.io/4510826451828736',
  release: `scantodesk-web@${WEB_VERSION}`,
  environment: import.meta.env.DEV ? 'development' : (import.meta.env.VITE_API_BASE?.includes('staging') ? 'staging' : 'production'),

  // Tracing 설정
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 1.0, // 100% for now, lower in production if needed

  // Distributed Tracing: API 서버로 trace 전파
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/api\.scantodesk\.app/,
  ],

  // Breadcrumbs
  maxBreadcrumbs: 100,

  // 태그 설정
  initialScope: {
    tags: {
      component: 'web',
      'app.type': 'web',
    },
  },
});

// Logger 초기화 (모든 로그 캡처)
import { initLogger } from './logger.js';
initLogger();

// i18n 초기화
import { initI18n } from './i18n/index.js';
initI18n();

// 디바이스 이름 초기화
import { initDeviceName } from './utils/device-info.js';
initDeviceName();

// 앱 마운트
const app = mount(App, {
  target: document.getElementById('app'),
});

export default app;
